<template>
  <div
    class="header-position bg px-0 px-lg-4"
    :class="{ 'navbar--hidden': !showNavbar }"
  >
    <div class="container-fluid p-0">
      <nav class="navbar navbar-expand-lg navbar-dark stick_nav bg">
        <div class="logo_div_wrapper">
          <router-link
            :to="'/'"
            exact
            class="d-flex justify-content-center align-items-center"
          >
            <img class="logo-img" src="../assets/top-menu/logo-rbh-go.png" />
          </router-link>
        </div>

        <button
          class="navbar-toggler custom-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon icon-bar"></span>
        </button>

        <!-- This is the collapsible content -->
        <div class="collapse navbar-collapse" id="navbarNav">
          <!-- Desktop Navigation Menu -->
          <div class="nav-menu-container d-none d-lg-flex">
            <div class="menu-border-container">
              <ul class="navbar-nav">
                <li class="nav-item">
                  <router-link class="nav-link" :to="'/'">Home</router-link>
                </li>
                <li class="nav-item">
                  <router-link class="nav-link" :to="'/live'"
                    >Live TV</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link class="nav-link" :to="'/radio/4'"
                    >Radio</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link class="nav-link" :to="'/news/'"
                    >News</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link class="nav-link" :to="'/vod/'">VOD</router-link>
                </li>
                <li class="nav-item">
                  <router-link class="nav-link" :to="'/podcast/'"
                    >Podcast</router-link
                  >
                </li>
              </ul>
            </div>
          </div>

          <!-- Desktop Right Icons -->
          <div class="nav-icons-container d-none d-lg-flex">
            <div class="search-icon-wrapper">
              <router-link
                class="icon"
                :to="'/search'"
                :class="{ 'none-active': activeid == '/search' }"
              >
                <img src="../assets/top-menu/search-ico.png" />
              </router-link>
            </div>
            <!-- <div class="notification-icon-wrapper">
              <a href="#" class="icon">
                <img src="../assets/icon/notification.svg" />
              </a>
            </div> -->
            <div class="ml-2 d-none d-lg-flex" v-if="!authenticated">
              <router-link class="icon" :to="'/login'" exact>
                <img src="../assets/icon/profile.svg" />
              </router-link>
            </div>
            <div class="ml-2 d-none d-lg-flex" v-else>
              <li
                class="nav-item d-flex justify-content-end align-items-center flex-lg-row flex-column my-lg-0 mt-3"
                data-toggle="collapse"
                data-target=".navbar-collapse.show"
              >
                <a
                  class="nav-link dropdown-toggle"
                  style="width:100%;"
                  href="#"
                  id="navbarDropdownRadio"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  ><img src="../assets/icon/profile.svg"
                /></a>
                <div
                  class="dropdown-menu"
                  aria-labelledby="navbarDropdownRadio"
                  style="background: #292929;"
                >
                  <div class="container">
                    <div class="row d-flex justify-content-start">
                      <div class="col-12">
                        <div
                          style="width:100%"
                          class="d-flex flex-sm-row flex-column flex-lg-wrap justify-content-start"
                        >
                          <router-link class="" :to="'/profile'" exact>
                            <div
                              class="w-100 d-flex flex-row justify-content-start align-items-center"
                            >
                              <img
                                src="../assets/icon/profile.svg"
                                class="dropdown-menu-icon"
                                alt=""
                              />
                              <span class="ml-2 text-white"
                                >Manage Profile</span
                              >
                            </div>
                          </router-link>
                        </div>
                      </div>
                      <div
                        class="col-12 mt-2 cursor-pointer"
                        @click="signOut()"
                      >
                        <div
                          style="width:100%"
                          class="d-flex flex-sm-row flex-column flex-lg-wrap justify-content-start"
                        >
                          <div
                            class="w-100 d-flex flex-row justify-content-start align-items-center"
                          >
                            <img
                              src="../assets/icon/profile.svg"
                              class="dropdown-menu-icon"
                            />
                            <span class="ml-2 menu-text">Logout</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </div>
          </div>

          <!-- Mobile menu - will be hidden until hamburger is clicked -->
          <div class="mobile-menu-container">
            <ul class="navbar-nav mobile-nav">
              <li
                class="nav-item mobile-nav-item"
                data-toggle="collapse"
                data-target=".navbar-collapse.show"
              >
                <router-link class="nav-link" :to="'/'">Home</router-link>
              </li>
              <li
                class="nav-item mobile-nav-item"
                data-toggle="collapse"
                data-target=".navbar-collapse.show"
              >
                <router-link class="nav-link" :to="'/live'">TV</router-link>
              </li>
              <li
                class="nav-item mobile-nav-item"
                data-toggle="collapse"
                data-target=".navbar-collapse.show"
              >
                <router-link class="nav-link" :to="'/news'">News</router-link>
              </li>
              <li
                class="nav-item mobile-nav-item"
                data-toggle="collapse"
                data-target=".navbar-collapse.show"
              >
                <router-link class="nav-link" :to="'/radio/4'"
                  >Radio</router-link
                >
              </li>
              <li
                class="nav-item mobile-nav-item"
                data-toggle="collapse"
                data-target=".navbar-collapse.show"
              >
                <router-link class="nav-link" :to="'/vod/'">VOD</router-link>
              </li>
              <li
                class="nav-item mobile-nav-item"
                data-toggle="collapse"
                data-target=".navbar-collapse.show"
              >
                <router-link class="nav-link" :to="'/podcast/'"
                  >Podcast</router-link
                >
              </li>
              <li
                class="nav-item mobile-nav-item"
                data-toggle="collapse"
                data-target=".navbar-collapse.show"
              >
                <router-link class="nav-link" :to="'/search'"
                  >Search <img src="../assets/top-menu/search-ico.png"
                /></router-link>
              </li>
            </ul>

            <!-- Mobile login/profile section -->
            <div class="mobile-user-section">
              <div
                class="w-100 d-flex justify-content-center"
                v-if="!authenticated"
              >
                <router-link
                  class="mobile-icon"
                  :to="'/login'"
                  exact
                  data-toggle="collapse"
                  data-target=".navbar-collapse.show"
                >
                  <div
                    class="w-100 d-flex flex-row justify-content-center align-items-center"
                  >
                    <img src="../assets/icon/profile.svg" />
                    <span class="ml-3">Login</span>
                  </div>
                </router-link>
              </div>
              <div class="ml-2 d-flex" v-else>
                <li
                  class="nav-item mobile-profile-item"
                  data-toggle="collapse"
                  data-target=".navbar-collapse.show"
                >
                  <a
                    class="nav-link dropdown-toggle"
                    href="#"
                    id="navbarDropdownRadio"
                    role="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    ><img src="../assets/icon/profile.svg"
                  /></a>
                  <div
                    class="dropdown-menu"
                    aria-labelledby="navbarDropdownRadio"
                    style="background: #292929;"
                  >
                    <div class="container">
                      <div class="row d-flex justify-content-start">
                        <div class="col-12 my-2">
                          <div
                            class="d-flex flex-sm-row flex-column flex-lg-wrap justify-content-start "
                          >
                            <router-link class="" :to="'/profile'" exact>
                              <div
                                class="w-100 d-flex flex-row justify-content-start align-items-center"
                              >
                                <img
                                  src="../assets/icon/manage-profile.svg"
                                  class="dropdown-menu-icon"
                                  alt=""
                                />
                                <span class="ml-2 text-white"
                                  >Manage Profile</span
                                >
                              </div>
                            </router-link>
                          </div>
                        </div>
                        <div class="col-12 my-2" @click="signOut()">
                          <div
                            class="d-flex flex-sm-row flex-column flex-lg-wrap justify-content-start"
                          >
                            <div
                              class="w-100 d-flex flex-row justify-content-start align-items-center"
                            >
                              <img
                                src="../assets/icon/logout.svg"
                                class="dropdown-menu-icon"
                              />
                              <span class="ml-2 menu-text">Logout</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
// is-active
import RadioService from "../static/json_dummy/radio.json";
import { mapGetters, mapActions } from "vuex";
export default {
  data: function() {
    return {
      activeid: "",
      filterItem: RadioService.response,
      showNavbar: true,
      lastScrollPosition: 0,
    };
  },
  created: function() {
    this.setActiveId();
  },
  methods: {
    ...mapActions({
      signOutAction: "auth/signOut",
    }),

    signOut() {
      this.signOutAction().then(() => {
        this.$router.replace({
          name: "home_new",
        });
      });
    },
    setActiveId() {
      this.activeid = this.$route.name;
    },
    onScroll() {
      const currentScrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;
      if (currentScrollPosition < 0) {
        return;
      }
      if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 90) {
        return;
      }
      this.showNavbar = currentScrollPosition < this.lastScrollPosition;
      this.lastScrollPosition = currentScrollPosition;
    },
  },
  mounted() {
    this.setActiveId();
    window.addEventListener("scroll", this.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  computed: {
    ...mapGetters({
      authenticated: "auth/authenticated",
    }),
  },
};
</script>

<style scoped>
.header-position {
  position: relative;
  width: 100%;
  z-index: 9999999 !important;
  margin-bottom: 0px;
  margin-top: 16px;
}
.bg {
  background: #000000;
}
.navbar-collapse {
  display: flex;
  justify-content: space-between;
}
.nav-menu-container {
  display: flex;
  justify-content: center;
  flex-grow: 1;
}
.menu-border-container {
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  padding: 8px 12px;
  background: rgba(30, 30, 30, 0.5);
}
.nav-icons-container {
  display: flex;
  align-items: center;
  margin-right: 20px;
}
.navbar-nav {
  display: flex;
  justify-content: center;
}
.nav-item {
  width: auto;
  margin: 0 4px;
  font-family: "Poppins", sans-serif !important;
}
.search-icon-wrapper,
.notification-icon-wrapper {
  margin: 0 10px;
}
a,
.menu-text {
  color: #ffffff;
  font-family: "Poppins", sans-serif !important;
  font-size: 14px;
}
.navbar-dark .navbar-nav .nav-link {
  font-family: "Poppins", sans-serif !important;
  color: #ffffff;
  cursor: pointer;
  font-weight: normal !important;
  font-size: 16px !important;
  line-height: 19px;
  padding: 16px !important;
  text-transform: none;
  border-radius: 8px;
  transition: all 0.3s ease;
  margin: 4px 0;
}
.navbar-dark .navbar-nav .nav-link:hover {
  color: #fab900;
  background-color: #222222;
}
.navbar-dark .navbar-nav .router-link-exact-active {
  color: #fab900;
  background-color: #222222;
}
.logo_div_wrapper {
  width: 110px;
  margin: 0 10px 0;
}
.logo-img {
  width: 100%;
}
.search-icon {
  width: 21px;
}
.icon {
  width: 24px;
}
.icon img {
  width: 100%;
}

/* Mobile menu styles */
.mobile-menu-container {
  display: none;
}
.mobile-nav {
  flex-direction: column;
  width: 100%;
  padding-top: 20px;
}
.mobile-nav-item {
  width: 100%;
  margin: 5px 0;
  text-align: center;
}
.mobile-user-section {
  width: 100%;
  margin-top: 20px;
  text-align: center;
}
.mobile-icon {
  width: auto;
}
.mobile-profile-item {
  width: 100%;
}

.stick_nav {
  margin-top: 0 !important;
}

@media only screen and (max-width: 992px) {
  .stick_nav {
    margin-top: 8px !important;
  }

  .header-position {
    top: 0;
    margin-bottom: 0px;
    margin-top: 0px;
  }
  .nav-item {
    margin: 0;
  }
  .logo_div_wrapper {
    width: 80px;
    margin: 0 5px 0;
  }

  .navbar-collapse {
    flex-direction: column;
    background: #000000;
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    padding: 20px 0;
  }

  .mobile-menu-container {
    display: block;
    width: 100%;
  }

  /* Ensure menu is hidden by default */
  .collapse:not(.show) {
    display: none !important;
  }

  /* Menu when expanded */
  .navbar-collapse.show,
  .navbar-collapse.collapsing {
    min-height: 100vh;
  }

  /* Fix menu item styling for mobile */
  .navbar-dark .navbar-nav .nav-link {
    padding: 12px 0;
    color: #ffffff;
    font-size: 20px;
    font-weight: bold;
  }

  .navbar-dark .navbar-nav .router-link-exact-active {
    color: #fab900;
    background-color: #222222;
    border-radius: 8px;
  }

  .custom-toggler {
    z-index: 10;
  }
}

/* Hide mobile menu by default */
/* @media (max-width: 767.98px) {
  .stick_nav {
    margin-top: 0 !important;
  }
} */

.navbar-toggler:focus {
  outline: none;
}

.custom-toggler.navbar-toggler {
  border-color: rgb(250, 185, 0);
  padding: 0.15rem 0.55rem;
  font-size: 1rem;
}

.custom-toggler .navbar-toggler-icon {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(250,185,0, 0.7)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 8h24M4 16h24M4 24h24'/%3E%3C/svg%3E");
}

.dropdown-menu {
  right: 0% !important;
  left: unset !important;
}
</style>
